import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backComp: {
      width: 48,
      height: 48,
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      justifyItems: "center",
    },
    nextComp: {
      width: 48,
      height: 48,
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      justifyItems: "center",
    },
    fitContainer: {
      width: "inherit",
    },
  }),
);

const useAppStepper = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();

  return {
    styles,
    classes,
    atomicStyles,
  };
};

export { useAppStepper as default };
